<template>
    <Dialog
        :modal="true"
        v-model:visible="abrir_modal"
        :closable="true"
        class="col-12 sm:col-12 md:col-6"
    >
        <div class="solicitud-confirmar">
            <div class="solicitud-confirmar-imagen">
                <img src="/images/car.png" />
            </div>
            <div class="solicitud-confirmar-texto">
                ¿Está seguro de enviar la solicitud para revisión?
            </div>
        </div>
        <template #footer>
            <Button
                label="Atrás"
                icon="fas fa-arrow-left"
                class="p-button-danger mr-2 p-button-rounded"
                v-tooltip.bottom="'Atrás'"
                @click="abrir_modal = false"
            />
            <Button
                label="Enviar solicitud"
                icon="fas fa-check"
                class="p-button-info p-mr-2 p-button-rounded"
                v-tooltip.bottom="'Enviar solicitud'"
                @click="abrir_modal = false"
            />
        </template>
    </Dialog>
</template>

<script>
export default {
    name: "solicitud-confirmar-component",
    props: {},
    data() {
        return {
            abrir_modal: false,
        };
    },
    methods: {},
    validations() {},
    mounted() {
        this.emitter.on("solicitud-confirmar", () => {
            this.abrir_modal = true;
        });
    },
};
</script>

<style>
.solicitud-confirmar {
    padding: 0 15px;
    display: flex;
}

.solicitud-confirmar-imagen {
    width: 25%;
}

.solicitud-confirmar-imagen img {
    padding: 10px;
}

.solicitud-confirmar-texto {
    padding: 0 20px;
    width: 75%;
    font-weight: bold;
    font-size: 25px;
}

.icono-mas {
    font-size: 40px !important;
    color: #689f38;
}

.icono-menos {
    font-size: 40px !important;
    color: #d32f2f;
}

@media screen and (max-width: 520px) {
    .solicitud-confirmar {
        flex-wrap: wrap;
    }
    .solicitud-confirmar-imagen,
    .solicitud-confirmar-texto {
        width: 100%;
    }

    .solicitud-confirmar-imagen img {
        margin: 0 auto;
    }
}
</style>
